<ng-container [formGroup]="formGroup">
  <span class="p-float-label">
    <p-password
      [id]="'float-input__' + fieldName"
      [feedback]="feedback"
      [toggleMask]="true"
      [formControlName]="fieldName"
      [class]="validation()"
    >
      <ng-template pTemplate="header" *ngIf="feedback">
        <h5>Придумайте пароль</h5>
      </ng-template>
      <ng-template pTemplate="footer" *ngIf="feedback">
        <p-divider></p-divider>
        <p class="mt-2">Пароль должен содержать</p>
        <ul
          class="pl-2 ml-2 mt-0"
          style="
            line-height: 1.5;
            font-size: 12px;
            list-style-type: circle;
            margin-left: 10px;
          "
        >
          <li>Строчные буквы</li>
          <li>Заглавные буквы</li>
          <li>Хотя бы одну цифру</li>
          <li>Один из спецсимволов $@!%?&</li>
          <li>Минимально состоять из 8-и символов</li>
        </ul>
      </ng-template>
    </p-password>
    <label [for]="'float-input__' + fieldName">{{ formatFieldName(placeholder) }}</label>
  </span>
  <app-error-message
    [control]="$any(formGroup.controls[fieldName])"
    [field]="fieldName"
    [label]="placeholder"
    [warn]="''"
  ></app-error-message>
</ng-container>
